import { db, type Documento } from './db.js'
import { addDocumento, deleteDocumento } from './crud.js'
import { comprimirImagem, nomeFotoObra } from '@utils/imagem.js'

export const CATEGORIA_FOTO_OBRA = 'Fotos de Obra'

const today = () => new Date().toISOString().slice(0, 10)

/**
 * Comprime e guarda uma foto do canteiro como Documento (categoria 'Fotos de Obra').
 * Retorna o id do documento para vincular no diário.
 */
export async function salvarFotoObra(
  file: File | Blob,
  extra: { topicoId?: string | undefined; observacoes?: string | undefined } = {},
): Promise<number> {
  const ehVideo = file.type.startsWith('video/')
  const blob = ehVideo ? file : await comprimirImagem(file)
  const nome =
    file instanceof File && file.name
      ? ehVideo
        ? file.name
        : file.name.replace(/\.\w+$/, '.jpg')
      : nomeFotoObra()
  return addDocumento(
    {
      nome,
      categoria: CATEGORIA_FOTO_OBRA,
      tipo: blob.type || 'image/jpeg',
      tamanho: blob.size,
      data: today(),
      ...(extra.topicoId ? { topicoId: extra.topicoId } : {}),
      ...(extra.observacoes ? { observacoes: extra.observacoes } : {}),
    },
    blob,
  )
}

export async function salvarFotosObra(
  files: (File | Blob)[],
  extra: { topicoId?: string | undefined; observacoes?: string | undefined } = {},
): Promise<number[]> {
  const ids: number[] = []
  for (const f of files) ids.push(await salvarFotoObra(f, extra))
  return ids
}

export async function getFotos(ids: number[]): Promise<Documento[]> {
  if (ids.length === 0) return []
  const rows = await db.documentos.bulkGet(ids)
  return rows.filter((d): d is Documento => Boolean(d))
}

export async function removerFoto(id: number): Promise<void> {
  await deleteDocumento(id)
}
